module.exports = __webpack_public_path__ + "img/DE03675.7a953a87.png";